import { ReactNode } from 'react'
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  SxProps,
  Theme,
  Typography
} from '@mui/material'
import { getResultConfigByLabel } from 'pages/Diagnostics/constants'

interface IDiagnosticResultCard {
  title: string
  image: string
  labelResultValue?: 0 | 1 | 2
  hideResult?: boolean
  size?: 'small' | 'medium' | 'large'
  onClick?: () => void
  sx?: SxProps<Theme>
  /** Camada absoluta sobre a imagem (mesmo box). */
  overlay?: ReactNode
}

const XRayDiagnosticResultCard: React.FC<IDiagnosticResultCard> = ({
  title,
  image,
  labelResultValue,
  hideResult = false,
  size = 'medium',
  onClick,
  sx,
  overlay
}) => {
  const resultConfig = getResultConfigByLabel(labelResultValue)

  return (
    <Card
      sx={[
        {
          width: size === 'small' ? 150 : size === 'large' ? 500 : { xs: 200 },
          minHeight: size === 'small' ? 200 : size === 'large' ? 'unset' : 300,
          bgcolor: 'tabBorder.main',
          border:
            !hideResult && resultConfig
              ? `2px solid ${resultConfig.color} !important`
              : '',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      onClick={onClick}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia component='img' image={image} alt={title} />
        {overlay}
      </Box>

      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flex: 1
        }}
      >
        <Typography
          gutterBottom
          variant='body1'
          component='div'
          textAlign='center'
        >
          {title}
        </Typography>
        {!hideResult && resultConfig && (
          <Typography
            variant='body2'
            display='flex'
            justifyContent='center'
            gap={1}
            sx={{ color: resultConfig.color, '& svg': { marginBottom: 0 } }}
          >
            {resultConfig.icon} {resultConfig.label}
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export default XRayDiagnosticResultCard
